document.addEventListener("DOMContentLoaded", function () {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let link = window.location.href.replace(queryString, '')
    let redirectLocation = urlParams.get('redirect-location');

    if(redirectLocation == 'true'){
        window.history.replaceState({ }, '', link);
        Cookies.set('countryInfoPopup', 'ok', { expires: 30 });
    }

    if(!Cookies.get('countryInfoPopup')){
        console.log('not kyki country popyp')
        $('#location-recommendation-form select').select2({
            minimumResultsForSearch: -1
        });
        const popup = document.querySelector('#countryInfoPopup');
        let formLocales = document.querySelector('#location-recommendation-form');

        if(formLocales != null){
            formLocales.addEventListener('submit',function (e) {
                e.preventDefault();
                let fieldCountry = e.target.querySelector('.field-country select').value;
                Cookies.set('countryInfoPopup', 'ok', { expires: 30 });
                if(fieldCountry !== ''){
                    let newURL = fieldCountry + '?redirect-location=true';
                    window.open(newURL, "_top");
                }else{
                    document.body.classList.remove('cookies-overlay');
                    $('#countryInfoPopup').removeClass('open');
                    if(!Cookies.get('sing-form-time')) {
                        const currentTime = new Date().getTime();
                        const expireTime = currentTime + 3 * 60 * 1000;
                        Cookies.set('sing-form-time', expireTime, {expires: 30});
                    }
                }
            })
        }
    }else{
        if(!Cookies.get('sing-form-time')){
            const currentTime = new Date().getTime();
            const expireTime = currentTime + 3 * 60 * 1000;
            Cookies.set('sing-form-time', expireTime, { expires: 30 });
        }else{
            const currentTime = new Date().getTime();
            const expireTime = Cookies.get('sing-form-time');
            if(currentTime>expireTime && !Cookies.get('sing-form')){
                $('#sing-pop').addClass('open');
            }
        }
    }
});

